import { SxProps, Theme } from '@mui/material';
import { badgeChipSx } from 'theme/components/chip';

const neutralChip = {
  ...badgeChipSx,
  backgroundColor: 'customGrey.medium',
  color: 'customGrey.dark'
} satisfies SxProps<Theme>;

export const screeningStatusChipSx = {
  neutralChip
};
